import { configureStore, EnhancedStore } from "@reduxjs/toolkit";
import { CombinedState, combineReducers } from "redux";

import {
  FormCompletion,
  formCompletionSlice,
} from "client/domain/Onboarding/formCompletionSlice";

import { errorSlice } from "./errorSlice";
import { merchantSlice } from "./merchantSlice";
import { persistMiddleware } from "./persistMiddleware";
import { userStateSlice } from "./userStateSlice";

const rootReducer = combineReducers({
  error: errorSlice.reducer,
  formCompletion: formCompletionSlice.reducer,
  merchant: merchantSlice.reducer,
  userState: userStateSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export function configureAppStore(
  preloadedState: Partial<RootState> = {}
): EnhancedStore<CombinedState<RootState>> {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(persistMiddleware),
    preloadedState,
  });
}

export const store = configureAppStore({});
export const formCompletionActions = formCompletionSlice.actions;
export type { FormCompletion };
